import { useContext } from 'react';
import { ProgressContext } from '../components/ProgressProvider';
export function useProgress() {
    var _a = useContext(ProgressContext), phase = _a.phase, setPhase = _a.setPhase, step = _a.step, setStep = _a.setStep, phases = _a.phases;
    return { phase: phase, setPhase: setPhase, step: step, setStep: setStep, phases: phases };
}
export default useProgress;
